import { all, call, put, takeLatest } from '@redux-saga/core/effects';

import { rejectErrorCodeHelper } from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  CREATE_IRA_APPLICATION_ACCOUNT_NUMBER,
  CREATE_IRA_APPLICATION_ACCOUNT_TYPE,
  CREATE_IRA_APPLICATION_FUNDING_AMOUNT,
  CREATE_IRA_APPLICATION_FUNDING_TYPE,
  CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
  CREATE_IRA_APPLICATION_TRANSFER_TYPE,
  DELETE_IRA_APPLICATION_FUNDING,
  UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER,
  UPDATE_IRA_APPLICATION_ACCOUNT_TYPE,
  UPDATE_IRA_APPLICATION_FUNDING_AMOUNT,
  UPDATE_IRA_APPLICATION_FUNDING_TYPE,
  UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
  UPDATE_IRA_APPLICATION_TRANSFER_TYPE,
} from '../actions/iraFunding/iraFundingActionConstants';
import {
  createIraFundingAccountNumberRequest,
  createIraFundingAmountRequest,
  updateIraFundingAccountNumberRequest,
  updateIraFundingAmountRequest,
  createIraApplicationTransferTypeRequest,
  updateIraApplicationTransferTypeRequest,
  createIraApplicationFundingTypeRequest,
  updateIraApplicationFundingTypeRequest,
  createIraApplicationAccountTypeRequest,
  updateIraApplicationAccountTypeRequest,
  createIraApplicationPaymentDeliveryTypeRequest,
  updateIraApplicationPaymentDeliveryTypeRequest,
  deleteIraApplicationFundingRequest,
} from '../../request/iraFundingRequests';
import {
  createIraApplicationAccountNumberError,
  createIraApplicationAccountNumberSuccess,
  createIraApplicationAccountTypeError,
  createIraApplicationAccountTypeSuccess,
  createIraApplicationFundingAmountError,
  createIraApplicationFundingAmountSuccess,
  createIraApplicationFundingTypeError,
  createIraApplicationFundingTypeSuccess,
  createIraApplicationPaymentDeliveryTypeError,
  createIraApplicationPaymentDeliveryTypeSuccess,
  createIraApplicationTransferTypeError,
  createIraApplicationTransferTypeSuccess,
  deleteIraApplicationFundingError,
  deleteIraApplicationFundingSuccess,
  updateIraApplicationAccountNumberError,
  updateIraApplicationAccountNumberSuccess,
  updateIraApplicationAccountTypeError,
  updateIraApplicationAccountTypeSuccess,
  updateIraApplicationFundingAmountError,
  updateIraApplicationFundingAmountSuccess,
  updateIraApplicationFundingTypeError,
  updateIraApplicationFundingTypeSuccess,
  updateIraApplicationPaymentDeliveryTypeError,
  updateIraApplicationPaymentDeliveryTypeSuccess,
  updateIraApplicationTransferTypeError,
  updateIraApplicationTransferTypeSuccess,
} from '../actions/iraFunding/iraFundingActions';

function* createIraApplicationAccountNumber({ payload }) {
  try {
    yield call(createIraFundingAccountNumberRequest, payload);
    yield put(createIraApplicationAccountNumberSuccess(true));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createIraApplicationAccountNumberError(errorMessage));
  }
}

function* updateIraApplicationAccountNumber({ payload }) {
  try {
    yield call(updateIraFundingAccountNumberRequest, payload);
    yield put(updateIraApplicationAccountNumberSuccess(true));
    if (payload?.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateIraApplicationAccountNumberError(errorMessage));
  }
}

function* createIraApplicationFundingAmount({ payload }) {
  try {
    yield call(createIraFundingAmountRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    yield put(createIraApplicationFundingAmountSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createIraApplicationFundingAmountError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateIraApplicationFundingAmount({ payload }) {
  try {
    yield call(updateIraFundingAmountRequest, {
      ApplicationUid: payload.ApplicationUid,
      data: payload.data,
    });
    yield put(updateIraApplicationFundingAmountSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateIraApplicationFundingAmountError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* createIraApplicationTransferType({ payload }) {
  try {
    yield call(createIraApplicationTransferTypeRequest, payload);
    yield put(createIraApplicationTransferTypeSuccess(true));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createIraApplicationTransferTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateIraApplicationTransferType({ payload }) {
  try {
    yield call(updateIraApplicationTransferTypeRequest, payload);
    yield put(updateIraApplicationTransferTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateIraApplicationTransferTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* createIraApplicationFundingType({ payload }) {
  try {
    yield call(createIraApplicationFundingTypeRequest, payload);
    yield put(createIraApplicationFundingTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createIraApplicationFundingTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateIraApplicationFundingType({ payload }) {
  try {
    yield call(updateIraApplicationFundingTypeRequest, payload);
    yield put(updateIraApplicationFundingTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateIraApplicationFundingTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* deleteIraApplicationFunding({ payload }) {
  try {
    yield call(deleteIraApplicationFundingRequest, payload);
    yield put(deleteIraApplicationFundingSuccess(true));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(deleteIraApplicationFundingError(errorMessage));
  }
}

function* createIraApplicationAccountType({ payload }) {
  try {
    yield call(createIraApplicationAccountTypeRequest, payload);
    yield put(createIraApplicationAccountTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createIraApplicationAccountTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateIraApplicationAccountType({ payload }) {
  try {
    yield call(updateIraApplicationAccountTypeRequest, payload);
    yield put(updateIraApplicationAccountTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateIraApplicationAccountTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* createIraApplicationPaymentDeliveryType({ payload }) {
  try {
    yield call(createIraApplicationPaymentDeliveryTypeRequest, payload);
    yield put(createIraApplicationPaymentDeliveryTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(createIraApplicationPaymentDeliveryTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateIraApplicationPaymentDeliveryType({ payload }) {
  try {
    yield call(updateIraApplicationPaymentDeliveryTypeRequest, payload);
    yield put(updateIraApplicationPaymentDeliveryTypeSuccess(payload.data));
    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(updateIraApplicationPaymentDeliveryTypeError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

export default function* fundingSaga() {
  yield all([
    takeLatest(
      CREATE_IRA_APPLICATION_ACCOUNT_NUMBER,
      createIraApplicationAccountNumber,
    ),
    takeLatest(
      UPDATE_IRA_APPLICATION_ACCOUNT_NUMBER,
      updateIraApplicationAccountNumber,
    ),
    takeLatest(
      CREATE_IRA_APPLICATION_FUNDING_AMOUNT,
      createIraApplicationFundingAmount,
    ),
    takeLatest(
      UPDATE_IRA_APPLICATION_FUNDING_AMOUNT,
      updateIraApplicationFundingAmount,
    ),
    takeLatest(
      CREATE_IRA_APPLICATION_TRANSFER_TYPE,
      createIraApplicationTransferType,
    ),
    takeLatest(
      UPDATE_IRA_APPLICATION_TRANSFER_TYPE,
      updateIraApplicationTransferType,
    ),
    takeLatest(
      CREATE_IRA_APPLICATION_FUNDING_TYPE,
      createIraApplicationFundingType,
    ),
    takeLatest(
      UPDATE_IRA_APPLICATION_FUNDING_TYPE,
      updateIraApplicationFundingType,
    ),
    takeLatest(DELETE_IRA_APPLICATION_FUNDING, deleteIraApplicationFunding),
    takeLatest(
      CREATE_IRA_APPLICATION_ACCOUNT_TYPE,
      createIraApplicationAccountType,
    ),
    takeLatest(
      UPDATE_IRA_APPLICATION_ACCOUNT_TYPE,
      updateIraApplicationAccountType,
    ),
    takeLatest(
      CREATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
      createIraApplicationPaymentDeliveryType,
    ),
    takeLatest(
      UPDATE_IRA_APPLICATION_PAYMENT_DELIVERY_TYPE,
      updateIraApplicationPaymentDeliveryType,
    ),
  ]);
}
